import { InfoProps } from './Info.type';

export const tabs: InfoProps['tabs'] = Object.freeze({
    about: {
        name: 'О нас',
    },
    news: {
        name: 'Новости',
    },
    documents: {
        name: 'Документы',
    },
    programs: {
        name: 'Программные модули',
    },
    companies: {
        name: 'Нам доверяют',
    },
    requisites: {
        name: 'Реквизиты',
    },
    contacts: {
        name: 'Контакты',
    },
});
